import React from 'react';

import {
  AddBoxIcon,
  AddressIcon,
  AlarmIcon,
  ApiIcon,
  ArrowCheckIcon,
  ArrowIcon,
  AssetIcon,
  BankIcon,
  BuildingIcon,
  CalculatorIcon,
  CancelIcon,
  CapRollIcon,
  ChatIcon,
  ClearFixIcon,
  ClockIcon,
  CollateralSafeIcon,
  ConfirmErrorIcon,
  ConfirmIcon,
  ConfirmInfoIcon,
  ConfirmSuccessIcon,
  ConfirmWarningIcon,
  CopyIcon,
  CreateListIcon,
  CreateNoticeIcon,
  DateIcon,
  DeleteIcon,
  DeployIcon,
  DisconnectIcon,
  DocumentCopyIcon,
  DocumentIcon,
  DollarIcon,
  DrawCreditCardIcon,
  EditPenIcon,
  EmailIcon,
  EntryIcon,
  ErrorFilledIcon,
  ErrorIcon,
  FileAddIcon,
  FileClockIcon,
  FileErrorIcon,
  FileSettingsIcon,
  FileUserIcon,
  FileWarningIcon,
  FingerIcon,
  FloatIcon,
  FolderInIcon,
  GeneralInfoIcon,
  HashTagIcon,
  HideIcon,
  HomeIcon,
  ImageIcon,
  InProgressIcon,
  InfoFilledIcon,
  InfoIcon,
  LeftRightExpandedIcon,
  LeftRightIcon,
  ListIcon,
  LockIcon,
  LogOutIcon,
  MenuIcon,
  MinusBoxIcon,
  MoreIcon,
  NoteIcon,
  OverwriteIcon,
  PercentageIcon,
  PhoneIcon,
  PrimaryIcon,
  QuestionIcon,
  RejectIcon,
  ResetIcon,
  RunIcon,
  SafetyIcon,
  ScheduleNotSetIcon,
  SearchIcon,
  SecureMessageIcon,
  ShowIcon,
  SuccessFilledIcon,
  SuccessIcon,
  SyncIcon,
  TaskIcon,
  ThunderIcon,
  TreeDiagramIcon,
  TriangleIcon,
  TrustIcon,
  UnlockIcon,
  UploadDocumentIcon,
  UploadedFileIcon,
  UserEditIcon,
  UserIcon,
  UserInfoRefreshIcon,
  UserRejectIcon,
  UserSuccessIcon,
  VariableIcon,
  ViewDetailIcon,
  WalletIcon,
  WarningFilledIcon,
  WarningIcon,
} from 'app/shared/componentsRestyled/coreDesignSystem/icons';

const iconComponentMap = {
  AddBoxIcon,
  AddressIcon,
  AlarmIcon,
  ApiIcon,
  ArrowCheckIcon,
  ArrowIcon,
  AssetIcon,
  BankIcon,
  BuildingIcon,
  CalculatorIcon,
  CancelIcon,
  CapRollIcon,
  ChatIcon,
  ClearFixIcon,
  ClockIcon,
  CollateralSafeIcon,
  ConfirmErrorIcon,
  ConfirmIcon,
  ConfirmInfoIcon,
  ConfirmSuccessIcon,
  ConfirmWarningIcon,
  CopyIcon,
  CreateListIcon,
  CreateNoticeIcon,
  DateIcon,
  DeleteIcon,
  DeployIcon,
  DisconnectIcon,
  DocumentCopyIcon,
  DocumentIcon,
  DollarIcon,
  DrawCreditCardIcon,
  EditPenIcon,
  EmailIcon,
  EntryIcon,
  ErrorFilledIcon,
  ErrorIcon,
  FileAddIcon,
  FileClockIcon,
  FileErrorIcon,
  FileSettingsIcon,
  FileUserIcon,
  FileWarningIcon,
  FingerIcon,
  FloatIcon,
  FolderInIcon,
  GeneralInfoIcon,
  HashTagIcon,
  HideIcon,
  HomeIcon,
  ImageIcon,
  InProgressIcon,
  InfoFilledIcon,
  InfoIcon,
  LeftRightExpandedIcon,
  LeftRightIcon,
  ListIcon,
  LockIcon,
  LogOutIcon,
  MenuIcon,
  MinusBoxIcon,
  MoreIcon,
  NoteIcon,
  OverwriteIcon,
  PercentageIcon,
  PhoneIcon,
  PrimaryIcon,
  QuestionIcon,
  RejectIcon,
  ResetIcon,
  RunIcon,
  SafetyIcon,
  ScheduleNotSetIcon,
  SearchIcon,
  SecureMessageIcon,
  ShowIcon,
  SuccessFilledIcon,
  SuccessIcon,
  SyncIcon,
  TaskIcon,
  ThunderIcon,
  TreeDiagramIcon,
  TriangleIcon,
  TrustIcon,
  UnlockIcon,
  UploadDocumentIcon,
  UploadedFileIcon,
  UserEditIcon,
  UserIcon,
  UserInfoRefreshIcon,
  UserRejectIcon,
  UserSuccessIcon,
  VariableIcon,
  ViewDetailIcon,
  WalletIcon,
  WarningFilledIcon,
  WarningIcon,
};

const DIRECTIONAL_VARIANTS = {
  ArrowDownIcon: { component: ArrowIcon, props: { direction: 'down' } },
  ArrowUpIcon: { component: ArrowIcon, props: { direction: 'up' } },
  EntryInIcon: { component: EntryIcon, props: { direction: 'down' } },
  EntryOutIcon: { component: EntryIcon, props: { direction: 'up' } },
};

const LEGACY_VALUE_MAP = {
  Acute: 'CapRollIcon',
  AddAd: 'FileAddIcon',
  Alarm: 'AlarmIcon',
  ArrowDownwardAlt: 'ArrowDownIcon',
  ArrowSplit: 'TreeDiagramIcon',
  ArrowUpwardAlt: 'ArrowUpIcon',
  AssignmentTurnedIn: 'TaskIcon',
  Block: 'RejectIcon',
  BookmarkCheck: 'CollateralSafeIcon',
  BookmarkManager: 'FolderInIcon',
  CalendarClock: 'DateIcon',
  Cancel: 'CancelIcon',
  ChecklistRtl: 'ListIcon',
  Close: 'ErrorIcon',
  ContactIcon: 'ChatIcon',
  Cottage: 'HomeIcon',
  DataAlert: 'ClearFixIcon',
  DataCheck: 'FloatIcon',
  DataLossPrevention: 'SearchIcon',
  Delete: 'DeleteIcon',
  DisabledByDefault: 'VariableIcon',
  DoNotDisturbOn: 'UserRejectIcon',
  DoneOutline: 'ArrowCheckIcon',
  Error: 'DisconnectIcon',
  EventAvailable: 'SecureMessageIcon',
  FactCheck: 'UserSuccessIcon',
  FormsAddOn: 'CreateListIcon',
  Handshake: 'TrustIcon',
  History: 'ResetIcon',
  HolidayVillage: 'ImageIcon',
  HomeWork: 'BuildingIcon',
  Info: 'InfoIcon',
  InputCircle: 'EntryOutIcon',
  LockReset: 'LockIcon',
  Mail: 'EmailIcon',
  MoreTime: 'CreateNoticeIcon',
  NewReleases: 'PrimaryIcon',
  NumberIcon: 'HashTagIcon',
  OtherHouses: 'BankIcon',
  OutputCircle: 'EntryInIcon',
  PatientList: 'FileUserIcon',
  PendingActions: 'FileClockIcon',
  PlaylistRemove: 'FileErrorIcon',
  Preliminary: 'SuccessIcon',
  Priority: 'SafetyIcon',
  Problem: 'FileWarningIcon',
  RocketLaunch: 'ThunderIcon',
  Schedule: 'ClockIcon',
  SearchCheck: 'ViewDetailIcon',
  Stack: 'CopyIcon',
  StackOff: 'OverwriteIcon',
  Stacks: 'AssetIcon',
  SyncDesktop: 'ApiIcon',
  TabMove: 'LogOutIcon',
  TaskAlt: 'GeneralInfoIcon',
  ThumbUp: 'FingerIcon',
  Update: 'SyncIcon',
  Warning: 'WarningIcon',
};

const formatIconName = exportName => {
  const withoutSuffix = exportName.replace(/Icon$/, '');

  return withoutSuffix
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
};

const directionalBaseKeys = new Set(
  Object.values(DIRECTIONAL_VARIANTS).map(({ component }) => {
    const entry = Object.entries(iconComponentMap).find(([, v]) => v === component);

    return entry ? entry[0] : null;
  }),
);

const baseIconOptions = Object.keys(iconComponentMap)
  .filter(key => !directionalBaseKeys.has(key))
  .map(key => ({
    name: formatIconName(key),
    value: key,
  }));

const directionalIconOptions = Object.entries(DIRECTIONAL_VARIANTS).map(([key]) => ({
  name: formatIconName(key),
  value: key,
}));

export const ALL_ICON_OPTIONS = [...baseIconOptions, ...directionalIconOptions].sort((a, b) =>
  a.name.localeCompare(b.name),
);

const directionalComponentCache = Object.fromEntries(
  Object.entries(DIRECTIONAL_VARIANTS).map(([key, { component, props }]) => {
    const WrappedIcon = React.memo(
      React.forwardRef((wrapperProps, ref) =>
        React.createElement(component, { ...props, ...wrapperProps, ref }),
      ),
    );
    WrappedIcon.displayName = key;

    return [key, WrappedIcon];
  }),
);

export const getIconComponentByValue = value => {
  if (value == null) {
    return null;
  }

  const liveComponent = iconComponentMap[value] || directionalComponentCache[value];

  if (liveComponent) {
    return liveComponent;
  }

  const resolvedValue = LEGACY_VALUE_MAP[value] || value;

  return iconComponentMap[resolvedValue] || directionalComponentCache[resolvedValue] || null;
};

const iconOptionsByValue = new Map(ALL_ICON_OPTIONS.map(opt => [opt.value, opt]));

export const findIconOptionByValue = value => {
  if (value == null) {
    return null;
  }

  const directMatch = iconOptionsByValue.get(value);

  if (directMatch) {
    return directMatch;
  }

  const resolvedValue = LEGACY_VALUE_MAP[value];

  if (resolvedValue == null) {
    return null;
  }

  return iconOptionsByValue.get(resolvedValue) || null;
};
